import { AuthService } from 'modules/auth';
import MembershipStore from 'modules/membership/MembershipStore';
import UserStore from 'modules/user/UserStore';

class DatahubServiceUtils {
  static getEventData = (prevLocation, curLocation) => {
    const { id, marketplaceId, subdomain } = MembershipStore;
    const { hash, marketplaceId: userId, agentId } = UserStore;
    const { areaId, adminRole } = AuthService;

    return {
      membershipUserHash: hash ? hash : '0',
      userAreaId: areaId,
      membership: id
        ? { id, marketplaceId, subdomain }
        : { id: 0, marketplaceId: 0, subdomain },
      marketplaceUser: userId ? { id: userId } : { id: 0 },
      marketplaceProduct: marketplaceId ? { id: marketplaceId } : { id: 0 },
      marketplaceAgentId: agentId,
      membershipRole: adminRole,
      fromUrl: `${prevLocation.pathname}${prevLocation.search}${prevLocation.hash}`,
      toUrl: `${curLocation.pathname}${curLocation.search}${curLocation.hash}`
    };
  };

  static analyticsEventBuilder = ({
    category,
    action,
    label,
    url,
    ...event
  }) => {
    const { id, marketplaceId, subdomain } = MembershipStore;
    const { areaId } = AuthService;

    return {
      eventAction: `${action}`,
      eventDispatchedBy: `${category}`,
      label: `${label}`,
      membership: id
        ? { id, marketplaceId, subdomain }
        : { id: 0, marketplaceId: 0, subdomain },
      userAreaId: areaId ?? 0,
      url: url ? `${url}` : '',
      ...event
    };
  };
}

export default DatahubServiceUtils;
